import {
    TrackingContextStateType,
    TrackingAction,
} from './TrackingContext.types';

export function trackingReducer(
    state: TrackingContextStateType,
    action: TrackingAction,
): TrackingContextStateType {
    switch (action.type) {
        case 'samplePlayed':
            if (!state.mapOfSamplesPlayed.has(action.payload.item.guid)) {
                state.mapOfSamplesPlayed.set(
                    action.payload.item.guid,
                    action.payload.item.guid,
                );
            }
            return {
                ...state,
            };
        case 'packPlayed':
            if (!state.mapOfDemosPlayed.has(action.payload.item.guid)) {
                state.mapOfDemosPlayed.set(
                    action.payload.item.guid,
                    action.payload.item.guid,
                );
            }
            return {
                ...state,
            };
        case 'rePackPlayed':
            if (!state.mapOfDemosPlayed.has(action.payload.item.guid)) {
                state.mapOfDemosPlayed.set(
                    action.payload.item.guid,
                    action.payload.item.guid,
                );
            }
            return {
                ...state,
            };
        case 'sampleCollectionInitialized':
            return {
                ...state,
            };

        default:
            return {
                ...state,
            };
    }
}
